import { render, staticRenderFns } from "./news_composite.vue?vue&type=template&id=73d9e014&scoped=true&"
import script from "./news_composite.vue?vue&type=script&lang=js&"
export * from "./news_composite.vue?vue&type=script&lang=js&"
import style0 from "./news_composite.vue?vue&type=style&index=0&id=73d9e014&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d9e014",
  null
  
)

export default component.exports